var childrenList = new Array();

// 报表路由
import AnalyzeReport from '../view/AnalyzeReport/_router'
pushArray(childrenList, AnalyzeReport.index)

// 报表路由
import TaxStatements from '../view/TaxStatements/_router'
pushArray(childrenList, TaxStatements.index)

// 明细管理路由
import BillSchedule from '../view/BillSchedule/_router'
pushArray(childrenList, BillSchedule.index)

// 合同管理路由
import contractInfo from '../view/contractInfo/_router'
pushArray(childrenList, contractInfo.index)

// 合同模版路由
import htmodel from '../view/htmodel/_router'
pushArray(childrenList, htmodel.index)

// 文件管理路由
import riskmanage from '../view/riskmanage/_router'
pushArray(childrenList, riskmanage.index)

// 银行资金路由
import bankfunds from '../view/bankfunds/_router'
pushArray(childrenList, bankfunds.index)

// 企业管理路由
import qymanage from '../view/qymanage/_router'
pushArray(childrenList, qymanage.index)


// 单位分类路由
import businessType from '../view/businessType/_router'
pushArray(childrenList, businessType.index)

// 费用报销路由
import expensereimburse from '../view/expensereimburse/_router'
pushArray(childrenList, expensereimburse.index)

// 费用报销明细路由
import expensereimburseDetails from '../view/expensereimburseDetails/_router'
pushArray(childrenList, expensereimburseDetails.index)

// 票据发票路由
import InvoiceReport from '../view/InvoiceReport/_router'
pushArray(childrenList, InvoiceReport.index)

// 字典管理路由
import GoodsDictionary from '../view/GoodsDictionary/_router'
pushArray(childrenList, GoodsDictionary.index)

// 库存管理路由
import InventoryFrom from './InventoryForm/_router'
pushArray(childrenList, InventoryFrom.index)

// 备用金路由
import dk_byj from './dk_byj/_router'
pushArray(childrenList, dk_byj.index)

// 库存管理路由
import gzuser from './gzuser/_router'
pushArray(childrenList, gzuser.index)


import gzdetils from './gzdetils/_router'
pushArray(childrenList, gzdetils.index)

// 发票管理路由
import InvoiceForm from '../view/InvoiceForm/_router'
pushArray(childrenList, InvoiceForm.index)

// 收支登记路由
import expenditure from '../view/expenditure/_router'
pushArray(childrenList, expenditure.index)
// 报表页面路由
import Report from '../view/Report/_router'
pushArray(childrenList, Report.index)

// 内部转账路由
import etransfer from '../view/etransfer/_router'
pushArray(childrenList, etransfer.index)

// 企业管理
import department from '../view/department/_router'
pushArray(childrenList, department.index)

// 操作指引路由
import eoperation from '../view/eoperation/_router'
pushArray(childrenList, eoperation.index)

// 分组路由
import egroup from '../view/egroup/_router'
pushArray(childrenList, egroup.index)

// 日报
import user_gzrb from '../view/user_gzrb/_router'
pushArray(childrenList, user_gzrb.index)

// 往来单位路由
import edepartment from '../view/edepartment/_router'
pushArray(childrenList, edepartment.index)

// 收支类别路由
import eszcnanghtype from '../view/eszcnanghtype/_router'
pushArray(childrenList, eszcnanghtype.index)

// 账户信息路由
import eszcnangh from '../view/eszcnangh/_router'
pushArray(childrenList, eszcnangh.index)

// 系统登录页面路由
import commen from '../view/common/_router'
pushArray(childrenList, commen.index)

//系统配置路由
import sys from '../view/sys/_router'
pushArray(childrenList, sys.index)

//系统配置路由
import type from '../view/type/_router'
pushArray(childrenList, type.index)

//人员班组信息
import user_bz from '../view/user_bz/_router'
pushArray(childrenList, user_bz.index)

//官网申请人员信息
import gw_squser from '../view/gw_squser/_router'
pushArray(childrenList, gw_squser.index)

//官网申请企业类型
import gw_qytype from '../view/gw_qytype/_router'
pushArray(childrenList, gw_qytype.index)

//官网套餐
import gw_qytc from '../view/gw_qytc/_router'
pushArray(childrenList, gw_qytc.index)

//打卡范围
import dk_fw from '../view/dk_fw/_router'
pushArray(childrenList, dk_fw.index)

//打卡记录
import dk_plan from '../view/dk_plan/_router'
pushArray(childrenList, dk_plan.index)

//请假记录
import dk_request from '../view/dk_request/_router'
pushArray(childrenList, dk_request.index)

//审批人配置
import dk_spr from '../view/dk_spr/_router'
pushArray(childrenList, dk_spr.index)

//流程模版
import process_template from '../view/process_template/_router'
pushArray(childrenList, process_template.index)

//流程节点
import process_node from '../view/process_node/_router'
pushArray(childrenList, process_node.index)

//班组项目信息
import user_bzxm from '../view/user_bzxm/_router'
pushArray(childrenList, user_bzxm.index)

//我的官网订单信息
import gw_order from '../view/gw_order/_router'
pushArray(childrenList, gw_order.index)

//deepseek
import deepseek from '../view/deepseek/_router'
pushArray(childrenList, deepseek.index)

//企业申报记录
import qy_gssb from '../view/qy_gssb/_router'
pushArray(childrenList, qy_gssb.index)

//利润报表
import caiwubb from '../view/caiwubb/_router'
pushArray(childrenList, caiwubb.index)

//报销登记
import bxdengji from '../view/bxdengji/_router'
pushArray(childrenList, bxdengji.index)

 export default {
    index: childrenList
}
function pushArray(obj1, obj2) {
    obj2.forEach(function (o) {
        obj1.push(o);
    })
}



// WEBPACK FOOTER //
// ./src/view/_router.js